const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
const CONFIG = {
  production: {
    API_ENDPOINT: 'https://api.miaovpn.com/api',
  },
  development: {
    API_ENDPOINT: 'http://miao.localhost:5000/api',
  },
  staging: {
    API_ENDPOINT: 'https://stg-401.miaovpn.com/api',
  },
};

module.exports = {
  // ENV,
  // API_ENDPOINT: CONFIG[ENV].API_ENDPOINT,
  ENV,
  API_ENDPOINT: CONFIG[ENV].API_ENDPOINT,
};
